import { getResponseV2 } from "../clients/client-v2";
export { OutstreamEnum } from "../types/config";
export const getConfig = getResponseV2;
export { getGeo } from '../core/geo';
